import { useSearchParams } from "react-router-dom";

export const PAGE_SIZE = 20;

/** Pagina dall'URL: `?pagina=` è 1-based per chi legge, qui torna 0-based. */
export function paginaDaUrl(sp: URLSearchParams): number {
  const n = Number(sp.get("pagina"));
  return Number.isInteger(n) && n > 1 ? n - 1 : 0;
}

export function Paginazione({ total, loading }: { total: number; loading: boolean }) {
  const [sp, setSp] = useSearchParams();
  const pagina = paginaDaUrl(sp);
  if (total === 0) return null;

  const da = pagina * PAGE_SIZE + 1;
  const a = Math.min(total, (pagina + 1) * PAGE_SIZE);
  const ultima = (pagina + 1) * PAGE_SIZE >= total;

  function vai(p: number) {
    setSp((prev) => {
      if (p > 0) prev.set("pagina", String(p + 1));
      else prev.delete("pagina");
      return prev;
    });
  }

  const bottone = "min-h-[44px] px-4 border border-border rounded-lg bg-card text-sm disabled:opacity-50";
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-muted-foreground tabular-nums">{da}–{a} di {total}</span>
      <div className="flex gap-2">
        <button type="button" disabled={pagina === 0 || loading} onClick={() => vai(pagina - 1)} className={bottone}>
          Indietro
        </button>
        <button type="button" disabled={ultima || loading} onClick={() => vai(pagina + 1)} className={bottone}>
          Avanti
        </button>
      </div>
    </div>
  );
}
